import { GiveawayStatus } from '@daredrop-com/rewards-api-contract';
import { trpc } from 'root/src/client/v2/trpc/trpc';
const STALE_TIME_MS = 1000 * 15;
// Creator-scoped giveaways for the redesign profile, via tRPC (giveaways.getUserGiveaways wraps the
// legacy GET_USER_GIVEAWAYS handler).
export const useCreatorGiveaways = (userId) => {
    var _a, _b;
    const query = trpc.giveaways.getUserGiveaways.useQuery({ userId, limit: 5 }, { enabled: Boolean(userId), staleTime: STALE_TIME_MS });
    const giveaways = (_b = (_a = query.data) === null || _a === void 0 ? void 0 : _a.giveaways) !== null && _b !== void 0 ? _b : [];
    return {
        active: giveaways.find(giveaway => giveaway.status === GiveawayStatus.Active),
        resolved: giveaways.filter(giveaway => giveaway.status === GiveawayStatus.Resolved),
        isLoading: query.isLoading,
    };
};
